// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3jgxO","errorLogs":"EditorFooter_errorLogs__3t1Ya"};